module.exports = __webpack_public_path__ + "static/img/collect_banner.99aac3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/CustomersInfo/collect_banner.png
// module id = 6dmI
// module chunks = 19